export default "__VITE_ASSET__BWD7eVAi__"